import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useExpertReportBlockRatingHistory } from '@/entities/expert-report';
import { HistoryDialog } from '@/shared/ui';
import { EvaluationBlockRatingVersion } from './EvaluationBlockRatingVersion';

type Props = {
  conversationId: number;
  expertReportId: number;
  blockId: number;
};

/**
 * История версий результата блока: результаты, полученные системой при каждом расчёте, и правки
 * пользователей — баллом, значением справочника и возвратом к результату системы — от свежих к старым.
 *
 * Открыта каждому, кто видит диалог, — правка результата тут ни при чём.
 */
export const EvaluationBlockRatingHistory: FC<Props> = ({ conversationId, expertReportId, blockId }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <HistoryDialog
      title={t('dialogs:expertReport.ratingHistory')}
      emptyText={t('dialogs:expertReport.ratingHistoryEmpty')}
      useHistory={useExpertReportBlockRatingHistory}
      params={{ conversationId, expertReportId, blockId }}
      getItemKey={(version) => `${version.createdAt}-${version.source}`}
      renderItem={(version) => <EvaluationBlockRatingVersion version={version} />}
    />
  );
};
